<div class="io-row no-gap align-items-center">
  <div class="icon icon-status-{{_statusId}}">
    <mat-icon>{{_icon}}</mat-icon>
  </div>
  <div *ngIf="!iconOnly">
    <small *ngIf="!nolabel">Status</small>
    <strong>{{ _statusName }}</strong>
  </div>
</div>